(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('DiscIbqDialogController', DiscIbqDialogController);

    DiscIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Disc', 'Audio', 'Collection', 'Participation'];

    function DiscIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Disc, Audio, Collection, Participation) {
        var vm = this;

        vm.disc = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.audio = Audio.query();
        vm.collections = Collection.query();
        vm.participations = Participation.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.disc.id !== null) {
                Disc.update(vm.disc, onSaveSuccess, onSaveError);
            } else {
                Disc.save(vm.disc, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:discUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setCoverFile = function ($file, disc) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        disc.coverFile = base64Data;
                        disc.coverFileContentType = $file.type;
                        disc.coverPath = $file.name;
                    });
                });
            }
        };

    }
})();
